interface CrscQuoteData {
    restUrlGenerateQuote: string;
    restUrlGenerateDraftOrder: string;
    restNonce: string;
    restNonceWoocommerceStore: string;
    i18n: {
        generating: string;
        error: string;
        viewQuote: string;
        downloadPdf: string;
    };
}

interface GenerateQuoteResponse {
    success: boolean;
    retrieval_url?: string;
    pdf_url?: string;
    message?: string;
}

const generateQuote = (): void => {
    const data = (window as any).crscQuoteData as CrscQuoteData | undefined;

    if (!data) {
        return;
    }

    const forms = document.querySelectorAll<HTMLFormElement>('.crsc-quote-button-form');

    forms.forEach((form) => {
        form.addEventListener('submit', async (event) => {
            event.preventDefault();

            const button = form.querySelector<HTMLButtonElement>('button[type="submit"]');
            const result = form.querySelector<HTMLElement>('.crsc-quote-button-result');
            const nonceField = form.querySelector<HTMLInputElement>('input[name="crsc_quote_nonce"]');
            const originalText = button ? button.innerText : '';

            if (button) {
                button.disabled = true;
                button.innerText = data.i18n.generating;
            }

            if (result) {
                result.innerHTML = '';
            }

            try {
                const generateQuoteResponse = await fetch(data.restUrlGenerateQuote, {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-WP-Nonce': data.restNonce,
                    },
                    body: JSON.stringify({
                        nonce: nonceField ? nonceField.value : '',
                    }),
                });

                const generateQuotePayload = (await generateQuoteResponse.json()) as GenerateQuoteResponse;

                if (!generateQuoteResponse.ok || !generateQuotePayload.success) {
                    throw new Error(generateQuotePayload.message || data.i18n.error);
                }

                if (button) {
                    button.style.display = 'none';
                }

                if (result) {
                    const links: string[] = [];

                    if (generateQuotePayload.retrieval_url) {
                        links.push(`<a href="${generateQuotePayload.retrieval_url}">${data.i18n.viewQuote}</a>`);
                    }

                    if (generateQuotePayload.pdf_url) {
                        links.push(`<a href="${generateQuotePayload.pdf_url}" target="_blank" rel="noopener noreferrer">${data.i18n.downloadPdf}</a>`);
                    }

                    result.innerHTML = links.join(' &nbsp;|&nbsp; ');
                }
            } catch (error) {
                if (result) {
                    result.innerHTML = `<span class="crsc-quote-button-error">${(error as Error).message || data.i18n.error}</span>`;
                }

                if (button) {
                    button.disabled = false;
                    button.innerText = originalText;
                }
            }
        });
    });
};

export default generateQuote;

document.addEventListener('DOMContentLoaded', () => {
    generateQuote();
});
